import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { eventBus } from '../hooks/eventBus.js';

export default function NotificationToast() {
  const [toasts, setToasts] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    return eventBus.on('notification', (n) => {
      const id = Date.now() + Math.random();
      const t = makeToast(id, n);
      setToasts(prev => [...prev, t]);
      setTimeout(() => setToasts(prev => prev.filter(x => x.id !== id)), 12_000);
    });
  }, []);

  function dismiss(id) { setToasts(prev => prev.filter(x => x.id !== id)); }

  return (
    <div className="fixed top-20 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map(t => (
        <button
          key={t.id}
          onClick={() => { dismiss(t.id); if (t.url) nav(t.url); }}
          className="text-left bg-white border border-crimson/30 shadow-panel rounded-md p-3 hover:bg-panel transition"
        >
          <div className="section-eyebrow">{t.eyebrow}</div>
          <div className="font-semibold text-navy mt-0.5">{t.title}</div>
          {t.body && <div className="text-sm text-ink mt-1">{t.body}</div>}
        </button>
      ))}
    </div>
  );
}

function makeToast(id, n) {
  switch (n.kind) {
    case 'ai_question':
      return { id, eyebrow: 'AI Question', title: 'Quick clarification?', body: n.question, url: `/ai-questions` };
    case 'followup_due':
      return { id, eyebrow: 'Follow-up Due', title: n.title, body: n.customer_name || '', url: `/followups` };
    case 'recap_ready':
      return { id, eyebrow: 'Weekly Recap', title: 'Your draft is ready', body: `Week of ${n.week_of}`, url: `/recap` };
    case 'new_prospect':
      return {
        id, eyebrow: `New ${n.stage === 'lead' ? 'Lead' : 'Prospect'}`,
        title: n.customer_name || n.name,
        body: n.rep_name ? `${n.rep_name}${n.domain && n.domain !== 'other' ? ` · ${n.domain.replace('_', ' ')}` : ''}` : '',
        url: `/pipeline/${n.opportunity_id}`,
      };
    default:
      return { id, eyebrow: 'Notice', title: n.kind, body: '' };
  }
}
